import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Link,
} from '@material-ui/core';
import { Button } from '@aws-amplify/ui-react';
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Branding, theme } from '../../branding';
import Footer from '../Footer/Footer';
import MFAAuthSetup from './mfaAuthenticatorSetup'; // Adjust the import path as needed
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import SpinnerPage from '../SpinnerPage/SpinnerPage';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../../common/service';
import { setUser } from '../../redux/actions';
const useStyles = makeStyles((theme) => ({
  rootContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
  card: {
    width: '55em',
    maxWidth: '90vw',
    overflow: 'auto',
  },
  cardMedia: {
    width: 150,
    height: 90,
    backgroundSize: 'contain',
  },
  messageHeading: {
    fontSize: '24px',
    fontWeight: '700',
    fontFamily: 'Roboto, sans-serif',
    color: Branding.primary,
    margin: '8px 0px 8px 0px',
  },
  messageHeading2: {
    fontSize: '18px',
    fontWeight: '700',
    fontFamily: 'Roboto, sans-serif',
    color: Branding.primary,
    margin: '8px 0px 8px 0px',
  },
  message: {
    fontSize: '16px',
    fontWeight: '400',
    fontFamily: 'Roboto, sans-serif',
    color: 'rgba(0,0,0,0.60)',
    align: 'center',
    padding: '0px 12px 0px 12px',
  },
  spinnerStyle: {
    color: '#0C938F',
    margin: '8px 0px 8px 0px',
  },
  mainGrid: {
    justifyContent: 'space-evenly',
    height: 'auto',
    margin: 0,
  },
  grid: {
    paddingLeft: '10%',
    paddingTop: '2em',
  },
  button: {
    width: '25%',
    borderRadius: '0px',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  link: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: Branding.link,
    '&:hover': {
      cursor: 'pointer',
      color: Branding.accent,
      opacity: Branding.opacityHover,
    },
  },
}));

const mapStateToProps = (state) => {
  return {
    user: state.app.user,
    lang: state.app.lang,
    tos: state.app.tos,
  };
};

const MFASelection = (props) => {
  const classes = useStyles();
  const { user } = useAuthenticator((context) => [context.user]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState('authenticator');
  const [verificationCode, setVerificationCode] = useState('');
  const [authenticatorSetupRequired, setAuthenticatorSetupRequired] = useState(
    props.isAuthenticatorSetupRequired || false
  );
  const [error, setError] = useState('');
  const [isSetupModalOpen, setIsSetupModalOpen] = useState(false);
  const [verifyTOTP, setVerifyTOTP] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setAuthenticatorSetupRequired(props.isAuthenticatorSetupRequired || false);
    if (!user.Session) {
      navigate('/', {
        replace: true,
      });
    }
  }, [props.isAuthenticatorSetupRequired, navigate, user]);

  const handleVerify = async (e) => {
    e.preventDefault();
    if (verificationCode === '' || verificationCode === null) {
      setError('The code is not correct, please enter it again.');
      return;
    }
    setError('');
    setIsLoading(true);
    try {
      await handleMfaSubmit(verificationCode);
      setVerificationCode('');
      navigate('/', {
        replace: true,
      });
    } catch (error) {
      if (error.name === 'CodeMismatchException') {
        setError('The code is not correct, please enter it again.');
      } else if (error.name === 'NotAuthorizedException') {
        setError('Session expired. Please sign in again.');
      } else {
        setError('An error occurred, please try again.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleMfaSubmit = async (code) => {
    if (verifyTOTP) {
      await Auth.verifyTotpToken(user, code);
      await Auth.setPreferredMFA(user, 'SOFTWARE_TOKEN_MFA');
      await Auth.rememberDevice();
      const currentUser = await Auth.currentAuthenticatedUser({ bypassCache: true });
      props.setUser(currentUser);
    } else {
      const confirmedUser = await Auth.confirmSignIn(user, code, 'SOFTWARE_TOKEN_MFA');
      await Auth.updateUserAttributes(user, { "custom:mfa_last_auth_time": Date.now().toString() });
      await Auth.rememberDevice();
      props.setUser(confirmedUser);
    }
  };

  if (isSetupModalOpen) {
    return (
      <MFAAuthSetup
        onClose={() => {
          setIsSetupModalOpen(false);
          setAuthenticatorSetupRequired(true);
        }}
        onSubmit={() => {
          setIsSetupModalOpen(false);
          setAuthenticatorSetupRequired(false);
          setVerifyTOTP(true);
        }}
      />
    );
  }
  if (isLoading) {
    return <SpinnerPage />;
  }
  return (
    <div className={classes.rootContainer}>
      <Grid container spacing={2} className={classes.mainGrid}>
        <Card variant="outlined" className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Grid className={classes.grid} container item xs={12} spacing={3}>
              <CardMedia
                className={classes.cardMedia}
                image={
                  'https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png'
                }
                title={Branding.appName}
              />
            </Grid>
            <Grid container className={classes.grid} style={{ paddingTop: '2em', paddingBottom: '1em' }}>
              <Typography className={classes.messageHeading} align="center">
                Additional security verification
              </Typography>
              <Typography className={classes.message} style={{ marginTop: '1em' }}>
                Secure your account by adding an additional verification to your password.
              </Typography>
              <Typography className={classes.messageHeading2} style={{ marginTop: '2em' }}>
                How should we contact you?
              </Typography>
            </Grid>
            <Grid container className={classes.grid} style={{ paddingTop: '0em', paddingBottom: '1em' }}>
              <Box component="div" align="center" style={{ marginTop: '0em' }}>
                <FormControl component="fieldset">
                  <RadioGroup name="contactMethod" value={selectedMethod}>
                    <FormControlLabel value="authenticator" control={<Radio />} label="Authenticator app" />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Grid>
            <Grid container className={classes.grid} style={{ paddingTop: '0em' }}>
              {selectedMethod === 'authenticator' && (
                <>
                  {!authenticatorSetupRequired ? (
                    <Box component="div" align="center" style={{ marginTop: '1em' }}>
                      <Typography className={classes.messageHeading2} align="left">
                        Please enter the code
                      </Typography>
                      <div style={{ position: 'relative', marginTop: '1em', width: '100%' }}>
                        <label
                          htmlFor="verificationCode"
                          style={{
                            position: 'absolute',
                            top: '-10px',
                            left: '10px',
                            backgroundColor: 'white',
                            padding: '0 5px',
                            fontSize: '14px',
                            color: error ? '#dc3545' : '#666',
                          }}
                        >
                          Verification Code
                        </label>
                        <input
                          id="verificationCode"
                          type="text"
                          autoFocus={true}
                          value={verificationCode}
                          onChange={(e) => setVerificationCode(e.target.value)}
                          size="50"
                          style={{
                            width: '100%',
                            padding: '12px',
                            border: `1px solid ${error ? 'red' : 'initial'}`,
                            borderRadius: '4px',
                            fontSize: '16px',
                          }}
                        />
                        {error && (
                          <Typography
                            style={{
                              color: 'red',
                              fontSize: '14px',
                              textAlign: 'left',
                            }}
                          >
                            {error}
                          </Typography>
                        )}
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: '2em',
                        }}
                      >
                        <Typography>
                          <Link onClick={() => signOut()} className={classes.link}>
                            Back
                          </Link>
                        </Typography>

                        <Button
                          onClick={handleVerify}
                          style={{
                            borderRadius: '20px',
                            fontSize: '14px',
                            paddingLeft: theme.spacing(5),
                            paddingRight: theme.spacing(5),
                            fontWeight: '700',
                            marginTop: '0em',
                          }}
                          variation="primary"
                          className={classes.button}
                        >
                          Verify
                        </Button>
                      </div>
                    </Box>
                  ) : (
                    <Typography className={classes.message} align="left" style={{ marginTop: '1em' }}>
                      To use this verification method you must set up the Authenticator App.
                      <button
                        onClick={() => setIsSetupModalOpen(true)}
                        style={{
                          background: 'none',
                          border: 'none',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          fontSize: '14px',
                          paddingRight: theme.spacing(5),
                          marginRight: theme.spacing(2),
                          fontWeight: '700',
                        }}
                        variation="primary"
                      >
                        Click here to set it up
                      </button>
                    </Typography>
                  )}
                </>
              )}
            </Grid>
            <Grid>
              <Footer></Footer>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
};

export default connect(mapStateToProps, { setUser })(MFASelection);
